import { OEBackend } from "@/graphql"

export const SendPmaxSummaryEmailMutation = OEBackend.graphql(`
    mutation SendPmaxEmailSummary($input: PMAXEmailSummaryInput!) {
        sendPmaxEmailSummary(input: $input) {
            possibleErrors {
                message
                code
                type
                description
            }
        }
    }
`)
